import { H2 } from "components/atoms/H2";
import { MenuListSkeleton } from "components/molecules/MenuListSkeleton";
import { menuHelper } from "features/menu/utils/menuHelper";
import { useCampaign } from "features/shared/hooks/useCampaign";
import { useFavorite } from "features/shared/hooks/useFavorite";
import Link from "next/link";
import { List } from "shared/components/molecules/List";
import { MenuGallelyCard } from "shared/features/Menu/components/MenuGallelyCard";
import { FortuneTeller, Fortune, TelFortune } from "shared/types";

interface Props {
  title: string;
  menus: Fortune[] | TelFortune[];
  fortuneTeller: FortuneTeller;
  className?: string;
}

export const FortuneTellerMenuList = ({
  title,
  menus,
  fortuneTeller,
  className,
}: Props) => {
  const { onClickFavorite } = useFavorite();
  const { showCampaignPromotion } = useCampaign({
    fortuneTellerId: fortuneTeller?.id,
  });

  if (!menus)
    return (
      <>
        <H2 tw="mb-5">{title}</H2>
        <MenuListSkeleton />
      </>
    );

  const renderMenu = (menu: Fortune | TelFortune) => {
    const { menuPagePath } = menuHelper(menu);
    return (
      <Link href={menuPagePath}>
        <a>
          <MenuGallelyCard
            tw="w-full"
            menu={menu}
            fortuneTeller={fortuneTeller}
            onClickFav={onClickFavorite}
            hasFreeUsage={menu.type === "tel" && showCampaignPromotion}
          />
        </a>
      </Link>
    );
  };

  return (
    <List
      tw="mb-6"
      renderTitle={<H2 tw="mb-5">{title}</H2>}
      data={menus}
      columns={2}
      renderItem={renderMenu}
      itemPadding
      bottomBorder={false}
      className={className}
    />
  );
};
